/**
 * Environment Configuration
 * Centralized environment variable reads for the application
 * All environment-dependent values should be read here
 */

// API Configuration
export const apiUrl = process.env.REACT_APP_API_URL || 'https://localhost:57923/api';
export const tokenUrl = process.env.REACT_APP_TOKEN_URL || 'https://myaccount-stg.timepayment.com/lesseeservice/api/oauth2/token';
export const payixUrl = process.env.REACT_APP_PAYIX_URL || 'https://timepaymentstaging.mobilizecollections.com';

// OAuth Configuration
export const AuthorizationClientId = process.env.REACT_APP_AUTHORIZATION_CLIENT_ID || '08930e0aa6a04568b64739bee31e7624';

// Application Configuration
const parseMobileViewBreakpoint = parseInt(process.env.REACT_APP_MOBILE_VIEW_BREAKPOINT || '1200', 10);
export const MobileViewBreakpoint = isNaN(parseMobileViewBreakpoint) ? 1200 : parseMobileViewBreakpoint;

const parseApiTimeout = parseInt(process.env.REACT_APP_API_REQUEST_TIMEOUT_MS || '30000', 10);
export const ApiRequestTimeoutMs = isNaN(parseApiTimeout) ? 30000 : parseApiTimeout;
export const IsAllowGuarantorSignoff = process.env.REACT_APP_ALLOW_GUARANTOR_SIGNOFF === 'true';
export const AppTitle = process.env.REACT_APP_APP_TITLE || 'MyAccount Manager';

// Error Messages
export const defaultErrorMessage = process.env.REACT_APP_DEFAULT_ERROR_MESSAGE || 'Something went wrong';
export const defaultNetworkErrorMessage = process.env.REACT_APP_DEFAULT_NETWORK_ERROR_MESSAGE || 'Network error, please try again later';

// Legacy export for backward compatibility
// This matches the structure from the old global.js and api-config.js
const config = {
  // From api-config.js
  apiUrl,
  tokenUrl,
  payixUrl,

  // From global.js
  AuthorizationClientId,
  defaultErrorMessage,
  defaultNetworkErrorMessage,
  MobileViewBreakpoint,
  ApiRequestTimeoutMs,
  IsAllowGuarantorSignoff,
  AppTitle
};

export default config;
